import { create } from 'zustand';

const ACTION_SHEET_MODAL_PREFIX = '__action-sheet-';

export const actionSheetModal = {
  inactiveName: '__inactive-action-sheet',
  nameFor(name: string) {
    return `${ACTION_SHEET_MODAL_PREFIX}${name}`;
  },
  matches(name?: string) {
    return name?.startsWith(ACTION_SHEET_MODAL_PREFIX) ?? false;
  },
  currentName(name?: string) {
    return this.matches(name) ? name : undefined;
  },
};

export interface ModalState<T> {
  isOpen: boolean;
  meta?: T;
}

interface ActionSheetStore<T = unknown> {
  map: Map<string, ModalState<T>>;
  setModal: (name: string) => (state: ModalState<T>) => void;
  current?: string;
  setCurrent: (name?: string) => void;
}

export const useModalStore = create<ActionSheetStore>((set) => ({
  map: new Map(),
  setModal: (name) => (state) => {
    set((prev) => {
      const prevState = prev.map.get(name);

      return {
        map: new Map(prev.map).set(name, { ...prevState, ...state }),
        current: name,
      };
    });
  },
  current: undefined,
  setCurrent: (name) => {
    set({ current: name });
  },
}));
